<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{item.cu_sellername}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户编号</label>
            <span class="weui-form-preview__value">{{item.cu_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{item.cu_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">品牌</label>
            <span class="weui-form-preview__value">{{item.cvd_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{item.orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">状态</label>
            <span class="weui-form-preview__value">{{item.cvd_businessstauts}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户项目名称</label>
            <span class="weui-form-preview__value">{{item.cvd_projectname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">发现商机</label>
            <span class="weui-form-preview__value">{{dateFormat(item.createTime,'yyyy-MM-dd')}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">{{ "客户拜访" }}</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">次数</label>
            <span class="weui-form-preview__value">{{item.cv_count}} 次</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">最近日期</label>
            <span class="weui-form-preview__value">{{dateFormat(item.cv_date,'yyyy-MM-dd')}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">{{ "样品报价" }}</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">次数</label>
            <span class="weui-form-preview__value">{{item.ir_count}} 次</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">最近日期</label>
            <span class="weui-form-preview__value">{{dateFormat(item.ir_date,'yyyy-MM-dd')}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">{{ "样品订单" }}</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">个数</label>
            <span class="weui-form-preview__value">{{item.ss_count}} 个</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">最近日期</label>
            <span class="weui-form-preview__value">{{dateFormat(item.ss_date,'yyyy-MM-dd')}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">{{ "销售报价" }}</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">次数</label>
            <span class="weui-form-preview__value">{{item.qu_count}} 次</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">最近日期</label>
            <span class="weui-form-preview__value">{{dateFormat(item.qu_date,'yyyy-MM-dd')}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">{{ "销售订单" }}</div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">订单数</label>
            <span class="weui-form-preview__value">{{item.sa_count}} 个</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">最近日期</label>
            <span class="weui-form-preview__value">{{dateFormat(item.sa_date,'yyyy-MM-dd')}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">订单总额</label>
            <span class="weui-form-preview__value">{{numberFormat(item.sa_total,'#,##0.##')}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出货总额</label>
            <span class="weui-form-preview__value">{{numberFormat(item.pi_total,'#,##0.##')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  },
  data() {
    return {

    }
  }
};
</script>